<template>
<div class="opDashboard">
    <vx-card style="min-height:540px;">
    <vue-good-table mode="remote" 
    :pagination-options="{
        enabled: true,
    }" 
    :sort-options="{
        enabled: false,
    }"
    :totalRows="totalRecords"
    :rows="rows"
    :columns="columns"
    :isLoading.sync="isLoading"
    @on-column-filter="onColumnFilter"
    @on-page-change="onPageChange"
    @on-row-dblclick="navigate"
    styleClass="vgt-table condensed"/>
    </vx-card>
</div>
</template>

<script>
import flatPickr from "flatpickr";
// import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
export default {
 
    data() {

        return {
               components: {
             flatPickr
           },
            isLoading: false,
            columns: [{
                    label: 'Op Number',
                    field: 'opNo',
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: " ", // placeholder for filter input
                        trigger: 'enter', //only trigger on enter not on keyup 
                   },
                },
                {
                    label: 'Op Date',
                    field: 'opDate',
                     type: 'date',
                    dateInputFormat: 'dd-mm-yyyy', 
                    dateOutputFormat: "dd-mm-yyyy",
                     filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: 'dd/mm/yy', // placeholder for filter input
                        trigger: 'enter', //only trigger on enter not on keyup 
                   },
                },
                {
                    label: 'Patient Name',
                    field: 'patientName',
                     filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: " ", // placeholder for filter input
                        trigger: 'enter', //only trigger on enter not on keyup 
                   },
                },
                {
                    label: 'Patient Phone No',
                    field: 'patientPhoneNo',
                     filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: " ", // placeholder for filter input
                        trigger: 'enter', //only trigger on enter not on keyup 
                   },
                },
                 {
                    label: 'Consulting Doctor',
                    field: 'doctorName',
                     filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: " ", // placeholder for filter input
                        trigger: 'enter', //only trigger on enter not on keyup 
                   },
                },
            ],
            rows: [],
            totalRecords: 0,
            serverParams: {
                companyId:this.$session.get('companyId'),
                filter: {},
                currentPage: 1,
                limit: 10

            },
        }
        },

            mounted() {
                  let inputs = [
            'input[placeholder="dd/mm/yy"]'
            ];
            inputs.forEach(function(input) {
            flatPickr(input, {
                // dateFormat: "m-d-Y",
                dateFormat: "d-m-Y",
                // mode: "range",
                allowInput: true
            });
            });
            this.loadItems();
            },

            methods: {
  
                updateParams(newProps) {
                    this.serverParams = Object.assign({}, this.serverParams, newProps);
                },
                onPageChange(params) {
                    console.log(params);
                    this.updateParams({
                        currentPage: params.currentPage
                    });
                    this.loadItems();
                },
                onColumnFilter(params) {
                    this.updateParams({
                        filter:params.columnFilters
                    });
                    this.loadItems();
                },
                loadItems() {
                 
                    this.$http.post(
                        "/quickOpDashboard",
                        JSON.stringify(this.serverParams), {
                            headers: {
                                "Content-Type": "application/json"
                            }
                        }).then(response => {
                        // this.totalRecords =Object.keys(this.$store.state.opList).length ;
                        // this.rows = this.$store.state.opList;
                        this.totalRecords =response.data.data.recordsTotal ;
                        this.rows = response.data.data.records;

                    });

                },

                navigate(item,index,event) {
                    console.log(item,index,event);
                    console.log(item.row.opNo);
                    var selectedopNo = item.row.opNo;
                    this.$router.push({
                        path: 'QuickOp',
                        query: {
                            opId: selectedopNo
                        }
                    })
                }

            }
        }
</script>

<style>
.vgt-table thead th {
    background: white;
}
.vgt-wrap__footer{
  background: white;
}
table.vgt-table{
    font-size:12px;
    border: none;
}
.vgt-right-align {
    text-align: left;
}
/* .vgt-responsive {
    min-height:488px;
} */
.vgt-table.condensed tr{
    height: 56px;
}
.vgt-table.condensed td{
    padding-top: 19px;
}
.vgt-input{
    border: none;
}
.vgt-wrap__footer{
border: none;
}
 .flatpickr-calendar{ 
    
     width: 305.625px !important; 
     /* height: 300.627px !important;  */
} 
.flatpickr-rContainer {
    width: 95% !important;
}
.dayContainer{
      min-width: 86% !important;
      max-width: 86% !important;
}
/* .flatpickr-current-month{
    width: 66%;
} */
/* .flatpickr-calendar .flatpickr-next-month{
    right: 0 !important;
} */
/*.flatpickr-months{
    width:100%;
} */ 

.flatpickr-monthDropdown-months{
    margin-left: -18%;
}
.flatpickr-monthDropdown-month{
    font-size: 11 !important;
}
.flatpickr-next-month{
    right: 57px !important;
}
.flatpickr-months{
    width: 97%;
}
</style>
